<template>
  <vue-modal id="changeAddressModal"
             classes="vue-modal-container"
             height="auto"
             name="change-address-modal"
             width="300px">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('change-address-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content">
      <div class="ui form">
        <div class="field">
          <label>
            {{ trans.country }}
            <country-select v-model="country"
                            :country="country"
                            topCountry="HU"/>
          </label>
          <label>
            {{ trans.zip }}
            <input v-model="zipCode"
                   type="text"
                   @keyup.enter="changeAddress">
          </label>
          <label>
            {{ trans.city }}
            <input v-model="city"
                   type="text"
                   @keyup.enter="changeAddress">
          </label>
          <label>
            {{ trans.address }}
            <input v-model="address"
                   type="text"
                   @keyup.enter="changeAddress">
          </label>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui positive button"
              @click="changeAddress">{{ trans.changeAddressBtnText }}
      </button>
    </div>
  </vue-modal>
</template>

<script>
// import utils from '@/utils'
import notify from '@/notify'
import Vue from 'vue'
import {mapState} from 'vuex'

export default Vue.extend({
  data () {
    return {
      country: this.$store.state?.user?.countryCode,
      zipCode: this.$store.state?.user?.zipCode,
      city: this.$store.state?.user?.city,
      address: this.$store.state?.user?.address,
    }
  },
  methods: {
    changeAddress () {
      const country = this.country
      const zipCode = this.zipCode
      const city = this.city
      const address = this.address
      if (country && zipCode && city && address && country !== '' && zipCode !== '' && city !== ''
        && address !== '') {
        const addressData = {
          countryCode: country,
          zipCode: zipCode,
          city: city,
          address: address,
        }
        this.$parent.$emit('changeAddress', addressData)
        console.log(addressData)
      } else {
        notify.warning('A módosításhoz az összes mezőt ki kell tölteni')
      }
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.changeAddressModal,
    }),
  },
})
</script>

<style scoped>

</style>
